module.exports = __webpack_public_path__ + "img/blog-list-sidebar.2671809d.png";